import { useState } from "react";

export const homeFaqs = [
  {
    q: "在哪里可以查到爆料短剧的完整演员表？",
    a: "进入短剧库，选择任意一部作品，详情页会按出场顺序列出全部主要演员及其饰演角色。你也可以直接在顶部搜索框输入演员姓名，反查他参演过的短剧。",
  },
  {
    q: "导演编剧信息会包含哪些内容？",
    a: "每部短剧的详情页都会标注导演、编剧与出品方，并附上主创在同类题材中的代表作，方便你判断这部作品的整体风格走向。",
  },
  {
    q: "拍摄花絮和幕后制作故事多久更新一次？",
    a: "编辑部会跟随当周热度较高的作品更新，通常每周整理两到三篇，涵盖现场布景、道具细节、灯光设计与剪辑取舍。",
  },
  {
    q: "剧集口碑评分是怎么算出来的？",
    a: "评分仅统计看过至少三分之一剧集的观众打分，并剔除异常刷分数据，最终按十分制换算展示，分数保留一位小数。",
  },
  {
    q: "榜单里的热度值代表什么？",
    a: "热度值综合了站内播放、收藏、评论与分享行为，反映的是近期讨论度，与口碑评分并不完全一致，建议结合两者一起参考。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
            <span className="h-1 w-1 rounded-full bg-primary-500" />
            常见问题
          </span>
          <h2 className="mt-2.5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            关于查剧，你可能想知道
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            这里整理了观众最常问的几个问题。如果还有别的疑问，可以到关于我们页面留言，编辑会定期回复。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {homeFaqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}